import { Box } from '@creditas-ui/layout';
import React from 'react';
import { Container } from './DrawerBody.style';

interface DrawerBodyProps {
  children: React.ReactNode;
  onClose?: (event: MouseEvent) => void;
}

const DrawerBody = ({ children, onClose, ...props }: DrawerBodyProps): JSX.Element => (
  <Container {...props}>
    <Box>{children}</Box>
  </Container>
);

export { DrawerBody };
